const STEP = Object.freeze({
  ACCOUNT: 'account',
  BUSINESS: 'business',
  CART: 'cart',
  PAYMENT: 'payment'
});

const STEP_STATUS = Object.freeze({
  ACTIVE: 'active',
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete'
});

// prettier-ignore
const STEP_ORDER = Object.freeze([
  STEP.CART,
  STEP.BUSINESS,
  STEP.ACCOUNT,
  STEP.PAYMENT
]);

// prettier-ignore
const STEP_ORDER_HAS_AUTH_ACCOUNT = Object.freeze([
  STEP.CART,
  STEP.BUSINESS,
  STEP.PAYMENT
]);

const ACTION = Object.freeze({
  SET_PASSWORD: 'set_password',
  SET_PAYMENT_INSTRUMENT: 'set_payment_instrument',
  NEXT_STEP: 'next_step',
  GO_TO_STEP: 'go_to_step',
  PLACE_ORDER_START: 'place_order_start',
  PLACE_ORDER_SUCCESS: 'place_order_success',
  PLACE_ORDER_ERROR: 'place_order_error'
});

export const CHECKOUT = {
  STEP,
  STEP_STATUS,
  STEP_ORDER,
  STEP_ORDER_HAS_AUTH_ACCOUNT,
  ACTION
};

export const PAYMENT_OPTIONS = Object.freeze({
  NEW_CARD: 'newCard',
  SAVED_CARDS: 'savedCards',
  APPLE_PAY: 'applePay'
});
